//
// Copyright (c) 2011-2017 by Curalate, Inc.
//
// This directive makes the basic functions of the jQuery library sticky-js (https://github.com/garand/sticky)
// accessible within angular (since full jQuery isn't available within controllers).

import { PAGE_HEADER_SELECTOR, MAIN_SCROLL_TARGET_SELECTOR } from 'app/constants/global-elements';

(function() {
  angular.module('curalate')
        .directive('sticky', () => ({
          restrict: 'A',
          scope: {
            topSpacing: '@',
            bottomSpacing: '@',
            className: '@',
            wrapperClassName: '@',
            getWidthFrom: '@',
            responsiveWidth: '@',
            innerScrollable: '@',
          },
          transclude: false,
          link(scope, element) {
            const topNavHeight = angular.element(PAGE_HEADER_SELECTOR).outerHeight();
            const scrollableElem = element.find(`.${scope.innerScrollable}`);
            const updateScrollableHeight = function() {
              if (scrollableElem.length) {
                scrollableElem.css('height', angular.element(window).height() - topNavHeight);
              }
            };
            const stickyOptions = {
              topSpacing: (scope.topSpacing || topNavHeight),
              bottomSpacing: scope.bottomSpacing,
              className: scope.className,
              wrapperClassName: scope.wrapperClassName,
              getWidthFrom: scope.getWidthFrom,
              responsiveWidth: scope.responsiveWidth,
            };

            element.sticky(stickyOptions);

            scope.$on('sticky:update', () => {
              element.sticky('update');
            });

            updateScrollableHeight();
            $(window).on('resize', updateScrollableHeight);

            $(MAIN_SCROLL_TARGET_SELECTOR).on('scroll.stickyjs', () => {
              element.sticky('update');
            });
          },
        }));
})();
